import slick from 'slick-carousel'
import $ from 'jquery'

export default {

    init() {

        $('.slick-slider--full').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            speed: 800,
            pauseOnHover: false,
            pauseOnFocus: false
        });


        $('.slick-slider--1').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            speed: 800,
            pauseOnHover: false,
            pauseOnFocus: false
        });
    }
}
